<template>
  <div>
    <div class="mb_controller_home h-100" v-if="loads">
      <!-- <DesktopInterstitial v-if="desktop" />
      <MobileInterstitial v-if="mobile" /> -->
      <NewsMastheadFeatured />

      <div class="position-relative main-list-wrapper">
        <div
          class="main-list-section d-flex justify-content-center flex-column"
        >
          <BeritaRails class="mt-5 mb-4" />
          <SuaraDewan class="my-4" />
          <div
            class="w-100"
            v-for="(items, index) in newsID"
            :key="'news_parent_' + index"
          >
            <NewsCustomRails
              :beritaParentId="items.id"
              :beritaParentTitle="items.title"
              class="my-4"
            />
          </div>
        </div>
        <div class="w-100">
          <!-- ads bottom -->
          <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
          <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
        </div>
      </div>
    </div>
    <div
      v-else
      style="min-height: 70vh; display: flex; align-items: center;justify-content: center;color: white;"
    >
      <p>loading</p>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
// ads
import billboardbannerbottom from "../components/ads/live/billboardBannerBottom";
import mrecbannerbottom from "../components/ads/live/mrecBannerBottom";

// rtmklik
import NewsMastheadFeatured from "@/components/carousel/news/newsPageMainCarousel.vue";
import BeritaRails from "../components/carousel/homepage/v2/beritaRails.vue";
import NewsCustomRails from "../components/carousel/news/newsCustomRails.vue";
import SuaraDewan from "../components/carousel/news/suaraDewan.vue";
// import DesktopInterstitial from "../components/ads/interstitial/desktopInterstitial.vue";
// import MobileInterstitial from "../components/ads/interstitial/mobileInterstitial.vue";
// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";

export default {
  data: function() {
    return {
      tablet: false,
      mobile: false,
      desktop: false,
      initializeContinueWatchingRails: false,
      loads: false,
      newsList: [],
      newsID: [
        {
          id: "22442",
          title: "Berita Perdana 2025",
        },
        {
          id: "22438",
          title: "Berita Mandarin 2025",
        },
        {
          id: "22440",
          title: "Berita Tamil 2025",
        },
        {
          id: "22441",
          title: "Malaysia Tonight 2025",
        },
        {
          id: "22287",
          title: "Kanta 744 Malam 2025",
        },
        {
          id: "12325",
          title: "Berita Perdana 2024",
        },
        {
          id: "12324",
          title: "Berita Mandarin 2024",
        },
        {
          id: "12322",
          title: "Berita Tamil 2024",
        },
        {
          id: "12323",
          title: "Malaysia Tonight 2024",
        },
        {
          id: "12327",
          title: "Kanta 744 Malam 2024",
        },
        {
          id: "5172",
          title: "Berita Perdana 2023",
        },
        {
          id: "5173",
          title: "Berita Mandarin 2023",
        },
        {
          id: "12315",
          title: "Berita Tamil 2023",
        },
        // {
        //   id: "6543",
        //   title: "Malaysia Tonight",
        // },
        {
          id: "5174",
          title: "News@10 2023",
        },
        {
          id: "9901",
          title: "Kanta 744",
        },
        {
          id: "7895",
          title: "Biz Malaysia",
        },
        {
          id: "38",
          title: "Berita Perdana 2022",
        },
        {
          id: "43",
          title: "Berita Mandarin 2022",
        },
        {
          id: "19",
          title: "Berita Tamil 2022",
        },
        {
          id: "274",
          title: "News@10 2022",
        },
      ],
    };
  },
  components: {
    NewsMastheadFeatured: NewsMastheadFeatured,
    // billboardBannerTop: billboardBannerTop,
    // mrecBannerTop: mrecBannerTop,
    // billboardBannerMiddle: billboardBannerMiddle,
    // mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom,
    mrecbannerbottom,
    BeritaRails,
    // MaintainanceDesktop,
    // MaintainanceMobile,
    NewsCustomRails: NewsCustomRails,
    SuaraDewan,
    // DesktopInterstitial,
    // MobileInterstitial,
  },
  methods: {
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "berita",
          site: "RTMKlik",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
  },
  created: function() {},
  mounted() {
    this.deviceCheck();
    setTimeout(
      function() {
        this.initializepageview();
      }.bind(this),
      200
    );

    setTimeout(
      function() {
        this.loads = !this.loads;
      }.bind(this),
      1000
    );
  },
};
</script>

<style scoped>
.bg {
  background: #111319;
}
</style>

<style>
.pre-formatted {
  white-space: pre;
}
</style>
